export enum Race {
  Malay = 1,
  Chinese = 2,
  Indian = 3,
  Others = 4,
}
